import React from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SignInModal from '../components/auth/SignInModal';

const SignIn: React.FC = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = (location.state as { from?: { pathname?: string } } | null)?.from?.pathname ?? '/';
  const redirectPath = from === '/chart' ? '/' : from;

  if (currentUser) {
    return <Navigate to={redirectPath} replace />;
  }

  const handleClose = (): void => {
    navigate('/', { replace: true });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center">
      <h1 className="sr-only">Sign In to Chart2Video — Animated Chart Maker</h1>
      <SignInModal
        onClose={handleClose}
        onSwitchToSignUp={() => navigate('/signup', { state: { from: location.state } })}
      />
    </div>
  );
};

export default SignIn;